import { Swiper } from 'swiper';
import { Autoplay } from 'swiper/modules';

export default class{

    /**
     * constructor
     */
    constructor(){
        this.slider = document.querySelectorAll('[data-about-futarigift-slider]');
    }

    /**
     * init
     */
    init(){
        this.slider.forEach(slider => {
            new Swiper(slider, {
                modules: [Autoplay],
                loop: true,
                speed: 10000,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false,
                },
                slidesPerView: 1.5,
                spaceBetween: 12,
                breakpoints: {
                    768: {
                        slidesPerView: 4,
                        spaceBetween: 24
                    },
                    1024: {
                        slidesPerView: 5,
                        spaceBetween: 24
                    }
                }
            });
        });
    }

}